module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-development-146.vue");


//////////////////
// WEBPACK FOOTER
// ./en/contribution/vux-development.md
// module id = 565
// module chunks = 199